module.exports = __webpack_public_path__ + "img/2x.d5936a5.jpg";